if (typeof ProductQuantity !== 'function') {
	class ProductQuantity extends HTMLElement {
		constructor() {
			super();

			this.isInCart = !!this.querySelector('cart-product-quantity');
			this.alertParent = this.isInCart ? this.closest('cart-form').parentElement : this.closest('form');
			this.alert = this.createAlert();
			this.addToCartButton = this.closest('form').querySelector('button[type="submit"]');
			this.removeFromCartBtn = this.closest('form').querySelector('a.remove');

			const qty = this.querySelector('.qty-selector');
			const qtyMinus = this.querySelector('.qty-minus');
			const qtyPlus = this.querySelector('.qty-plus');
			const qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1;
			const qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

			this.variantId = parseInt(qty.dataset.variantId);
			this.variantQtyInCart = 0;

			if (parseInt(qty.value) - 1 < qtyMin) {
				qtyMinus.classList.add('disabled');
			}

			if (parseInt(qty.value) + 1 > qtyMax) {
				qtyPlus.classList.add('disabled');
			}

			this.loadCartQuantity().then(
				() => this.setEventListeners(qty, qtyMinus, qtyPlus, qtyMin, qtyMax)
			);
		}

		setEventListeners(qty, qtyMinus, qtyPlus, qtyMin, qtyMax) {
			qty.addEventListener('change', () => {
				const currentQty = parseInt(qty.value);

				if (currentQty - 1 < qtyMin) {
					qtyMinus.classList.add('disabled');
				} else {
					qtyMinus.classList.remove('disabled');
				}

				if (currentQty + 1 > qtyMax) {
					qtyPlus.classList.add('disabled');
				} else {
					qtyPlus.classList.remove('disabled');
				}

				this.updateUI(qtyMax, qty);

				if (currentQty > qtyMax) {
					qty.value = qtyMax;
				}
			});

			qtyMinus.addEventListener('click', (e) => {
				e.preventDefault();

				if (qtyMinus.classList.contains('disabled')) {
					return;
				}

				const currentQty = parseInt(qty.value);

				if (currentQty - 1 >= qtyMin) {
					qty.value = currentQty - 1;
					qtyPlus.classList.remove('disabled');
				}

				if (currentQty - 1 <= qtyMin) {
					qtyMinus.classList.add('disabled');
				}

				this.updateUI(qtyMax, qty);
			});

			qtyPlus.addEventListener('click', (e) => {
				e.preventDefault();

				const currentQty = parseInt(qty.value);
				const nextQuantity = (this.isInCart ? 0 : this.variantQtyInCart) + currentQty + 1;

				if (nextQuantity > qtyMax) {
					this.showAlert();

					return;
				}

				if (currentQty + 1 <= qtyMax) {
					qty.value = currentQty + 1;
					qtyMinus.classList.remove('disabled');
				}

				if (currentQty + 1 >= qtyMax) {
					qtyPlus.classList.add('disabled');
				}

				this.updateUI(qtyMax, qty);
			});

			this.addToCartButton?.addEventListener('click', async (event) => {
				const nextQuantity = this.variantQtyInCart + parseInt(qty.value);

				if (nextQuantity <= qtyMax) {
					this.variantQtyInCart = nextQuantity;

					return;
				}

				event.preventDefault();
				event.stopPropagation();

				this.showAlert();
			});

			this.removeFromCartBtn?.addEventListener('click', () => {
				this.hideAlert();
			});
		}

		createAlert() {
			const container = document.createElement('span');
			container.className = 'alert alert--error alert-max-quantity';
			container.innerText = KROWN.settings.locales.products_max_quantity_reached;

			return container;
		}

		showAlert() {
			if (this.alertParent.querySelector('.alert-max-quantity') === null) {
				this.alertParent.insertAdjacentElement('afterbegin', this.alert);
			}
		}

		hideAlert() {
			if (!!this.alertParent.querySelector('.alert-max-quantity')) {
				this.alertParent.querySelector('.alert-max-quantity').remove();
			}
		}

		disableAddToCartButton() {
			if (!this.addToCartButton) {
				return;
			}

			this.addToCartButton.disabled = true;
			this.addToCartButton.classList.add('disabled');
		}

		enableAddToCartButton() {
			if (!this.addToCartButton) {
				return;
			}

			this.addToCartButton.disabled = false;
			this.addToCartButton.classList.remove('disabled');
		}

		updateUI(qtyMax, qty) {
			const nextQuantity = (this.isInCart ? 0 : this.variantQtyInCart) + parseInt(qty.value);

			if (nextQuantity > qtyMax) {
				this.disableAddToCartButton();
				this.showAlert();

				return;
			}

			this.enableAddToCartButton();
			this.hideAlert();
		}

		async loadCartQuantity() {
			this.variantQtyInCart = await this.getCartQuantityForVariant(this.variantId);
		}

		async getCartQuantityForVariant(variantId) {
      		try {
        		const result = await fetch('/cart.js');
        		const cart = await result.json();
        		const item = cart.items.find(i => i.variant_id === variantId);

				return item ? item.quantity : 0;
      		} catch {
        		return 0;
      		}
    	}
	}

  	if (typeof customElements.get('product-quantity') == 'undefined') {
    	customElements.define('product-quantity', ProductQuantity);
	}
}
